import { render } from "./BuyRequestDetail.vue?vue&type=template&id=6f6e249e&scoped=true"
import script from "./BuyRequestDetail.vue?vue&type=script&lang=js"
export * from "./BuyRequestDetail.vue?vue&type=script&lang=js"

import "./BuyRequestDetail.vue?vue&type=style&index=0&id=6f6e249e&lang=css"
import "./BuyRequestDetail.vue?vue&type=style&index=1&id=6f6e249e&lang=css"
import "./BuyRequestDetail.vue?vue&type=style&index=2&id=6f6e249e&lang=css"
import "./BuyRequestDetail.vue?vue&type=style&index=3&id=6f6e249e&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6e249e"]])

export default __exports__